export default __webpack_public_path__ + "media/images/link-9f37df0e82c0f627c09c320d60fb03c7.svg";